export const tryParseJSON = <T>(json: string, defaultValue?: T) => {
  try {
    return JSON.parse(json);
  } catch {
    return defaultValue;
  }
};
